import React from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';

/** Same pattern as unit costing / org-wise: controlled `Date`, MUI AdapterDayjs. */
const DatePickerInput = ({ label, value, onChange, disabled, maxDate, minDate }) => {
    return (
        <div
            className={`flex flex-col flex-1 w-full space-y-2 min-w-max ${
                disabled ? 'opacity-50' : ''
            }`}
        >
            <span className="text-lg font-bold text-gray-700 mt-2">{label}</span>
            <div className="w-full">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        className="w-full"
                        value={value}
                        onChange={(date) => {
                            if (date == null) {
                                return;
                            }
                            if (
                                typeof date.isValid === 'function' &&
                                !date.isValid()
                            ) {
                                return;
                            }
                            const js = date.toDate();
                            if (Number.isNaN(js.getTime())) {
                                return;
                            }
                            // Local calendar day (avoids UTC edge cases from raw toDate()).
                            onChange(
                                new Date(
                                    js.getFullYear(),
                                    js.getMonth(),
                                    js.getDate()
                                )
                            );
                        }}
                        views={['year', 'month', 'day']}
                        renderInput={(params) => <TextField {...params} />}
                        maxDate={maxDate}
                        disabled={disabled}
                        minDate={minDate}
                    />
                </LocalizationProvider>
            </div>
        </div>
    );
};

export default DatePickerInput;
